// External libraries
import React from 'react';
import styled from 'styled-components';

// Zocdoc libraries
import {
    blue100,
    DEPRECATED,
    slate70,
} from '@zocdoc-mezzanine/foundations-colors';
import { Check, Close, Dot } from '@zocdoc-frontend-common/assets-icons';

// CSDK
import { RULE_STATUS } from '../../utils/CreateAccountValidation/constants';

// Used for CreatePasswordV2
export const CreatePasswordRulesListItem = ({ status, message, datatest }) => {
    let bullet = null;
    let listColor = '';
    if (status === RULE_STATUS.VALID) {
        bullet = (
            <Bullet>
                <Check color="#00b389" />
            </Bullet>
        );
        listColor = '#00b389';
    } else if (status === RULE_STATUS.INVALID) {
        bullet = (
            <Bullet>
                <Close color={DEPRECATED.tertiaryCoral} />
            </Bullet>
        );
        listColor = DEPRECATED.tertiaryCoral;
    } else {
        bullet = (
            <Bullet isDot>
                <Dot color={slate70} />
            </Bullet>
        );
        listColor = blue100;
    }

    return (
        <RulesListItem
            color={listColor}
            data-status={status}
            data-test={datatest}
        >
            {bullet}
            {message}
        </RulesListItem>
    );
};

const Bullet = styled.div`
    height: 10px;
    width: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 5px;
    margin-left: 2px;
    font-size: ${p => (p.isDot ? '5px' : '10px')};
`;

const RulesListItem = styled.li`
    color: ${p => p.color};
    list-style-type: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    text-align: center;
`;

export default CreatePasswordRulesListItem;
